module.exports = __webpack_public_path__ + "img/IconInfo.bbeabfb2.svg";